import client from '../restClients/authenticatedBff';
import { createPasswordValidationErrorPayload } from 'ciam-self-service-shared';

const BFF_VALIDATE_PWD = window.REACT_APP_BFF_VALIDATE_PASSWORD;

export const validatePassword = async (pass) => {
  try {
    const response = await client.post(BFF_VALIDATE_PWD, { pass }, { withCredentials: true });

    // Handle success case
    if (response.data?.validationDetails?.isValid) {
      return { isValid: true, error: null };
    }

    // Handle failure case - 200 response with isValid: false
    const validationDetails = response.data?.validationDetails || null;
    if (!validationDetails?.isValid) {
      const errorPayload = createPasswordValidationErrorPayload(validationDetails);
      return { isValid: false, error: errorPayload };
    }

    // Fallback for unclear response
    const fallbackErrorPayload = createPasswordValidationErrorPayload(null);
    return { isValid: false, error: fallbackErrorPayload };
  } catch (error) {
    // Handle 403 forbidden or network errors
    const validationDetails = error.response?.status === 403 ? error.response.data?.validationDetails : null;
    const errorPayload = createPasswordValidationErrorPayload(validationDetails);
    return { isValid: false, error: errorPayload };
  }
};
